export enum ActionTypes {
  Login,
  Logout,
  SetProfile,
  SetURLPrefix,
  SetPrivilege
}